/** Question types whose `legacy_colors` flag adds `legacy-colors` to <html> (GRYP-9764). */
export const LEGACY_COLOR_TYPES: readonly string[] = [
  'dyngrid',
  'dyngrid-check',
  'placement',
  'image-highlight',
  'text-highlight',
];
